import { connect, Dispatch } from 'react-redux';

import { StoreState } from '../../../reducers';
import SynchronizationLogoutPopup from '../../../components/MultiAppAuthentication/SynchronizationLogoutPopup';
import {
	cancelSynchronizationLogoutPopup,
	deferSignOutUntilSyncComplete,
} from '../actions';

const mapStateToProps = (state: StoreState) => {
	const { multiAppAuthenticationInfos: { isSynchronizationLogoutPopupOpen } } = state;
	return {
		isDisplayed: isSynchronizationLogoutPopupOpen,
	};
};

const mapDispatchToProps = (dispatch: Dispatch<StoreState>) => ({
	onDeferLogout: () => dispatch(deferSignOutUntilSyncComplete()),
	onCancel: () => dispatch(cancelSynchronizationLogoutPopup()),
});

export default connect(mapStateToProps, mapDispatchToProps)(SynchronizationLogoutPopup);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/MultiAppAuthentication/SynchronizationLogoutPopup/index.tsx